import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { DatadogService } from '../../service';

export type ListUsersConfig = typeof ListUsersConfig._.Config;

export const ListUsersConfig = IntegrationConfig.make({
  service: DatadogService,
  name: Integration_Handler_Names_Enum.ListUsers,
  configSchema: z.object({
    emailPatternFilter: patternFilterSchema.optional(),
  }),
});
